

const CointainerFigureImage = props => {
    return (
        <div className="chart-container">
            <div className="dr-container">
                <div className="chart-title">
                    <h2 className="mb-0">{ props.title }</h2>
                </div>
            </div>
            <div className="dr-container-chart">
                <img className="chart-container-image" src={props.image} alt={props.title} />
                
                <ul className={"list-unstyled list-inline text-center legend " + (props.legendCSSClass ?? 'list-inline')}>
                    {props.legend && props.legend.map((item, i) => {
                            return (
                                <li className={item.customCSSClass ?? "list-inline-item"} key={i}>
                                    <div>
                                        {item.color && <span className="point" style={{backgroundColor: item.color}} />}
                                        <span className="legend-note">{item.title}</span>
                                    </div>
                                </li>
                            )
                    })}
                </ul>
                <p className="note text-center note-white">
                    {props.note ?? renderSource()}
                </p>
            </div>
        </div>
    ) 
}


const renderSource = () => {
    const l = document.getElementsByTagName('html')[0].getAttribute('lang');

    switch(l) {
        case 'en':
            return <span>SOURCE: FAO, 2021c.</span>
        case 'ru':
            return <span>Примечания. <sup>*</sup> Ввиду вероятностного характера этого показателя и пределов неопределенности, связанных с расчетом каждого из параметров модели, ФАО не публикует оценок РН, если они менее 2,5%. Это не позволяет оценить, выполнила ли уже страна данную задачу ЦУР.<br />
            ИСТОЧНИК: ФАO, 2021.</span>;
        case 'ar':
            return <span>.یمثل الخط المتقطع خط المراقبة تقریبا في جامو وكشمیر المتفق علیھ بین الھند وباكستان. ولم یتفق الطرفان بعد على الوضع النھائي لجامووكشمیر
            لمتتقرربعد الحدود النهائيةبينجمهوريةالسودانوجمهوريةجنوبالسودان <br />المصدر: منظمة الأغذية والزراعة، 2021.</span>
        case 'fr':
            return <span><sup>*</sup> En raison de la nature probabiliste de cet indicateur et des marges d’incertitude associées aux estimations de chaque paramètre du modèle, la FAO ne publie pas d’estimations de la prévalence de la sous-alimentation inférieures à 2,5 pour cent. Cela empêche de déterminer si un pays a ou n’a pas déjà atteint la cible de l’ODD.<br />SOURCE: FAO, 2021.</span>;
        case 'zh':
            return <span>虚线为印度和巴基斯坦商定的查谟和克什米尔的大致控制线。双方尚未商定查谟和克什米尔的最终地位。苏丹和南苏丹之间的最终边界尚未确定。<br />
            说明：地图中显示的界线和名称并不意味着粮农组织对任何国家、领地、城市、地区或其当局的法律地位、或对其边界或国界的划分表示任何意见</span>;
        case 'es':
            return <span>NOTA: Los límites y nombres que se muestran y las designaciones utilizadas en estos mapas no implican la opinión o expresión alguna por parte de la FAO con respecto a la condición jurídica de ningún país, territorio, ciudad o zona o de sus autoridades, o con respecto a la delimitación de sus fronteras y límites.<br />Fuente: FAO, 2021.</span>;
        default:
            return <span>NOTE: The boundaries and names shown and the designations used on these map(s) do not imply the expression of any opinion whatsoever on the part of FAO concerning the legal status of any country, territory, city or area or of its authorities, or concerning the delimitation of its frontiers and boundaries.<br /> SOURCE: FAO</span>;
    }
}


export default CointainerFigureImage;
